import { useContext } from "react";
import { PatientContext } from "../ActivePatients";
import { useAlertSetting } from "../../services/useData";
import { Card, Row, Col, Table } from "react-bootstrap";
import { MEASUREMENT, CONTEXT, UPPER_BOUND, LOWER_BOUND, SEND_ALERT, BG, FASTING, LOW_VALUE, NO_VALUES, BP, SYSTOLIC, DIASTOLIC, ALERT, SETTINGS, AFTER_MEAL } from "../../util/const";


const AlertSettingsDisplay = () => {

  const context = useContext(PatientContext);
  const fetchedData = useAlertSetting(context.patient.diabetesType);
  const settings = fetchedData.settings;

  if(settings !== undefined)
  {
    return (
      <Card className="mt-3">
        <Card.Header>{ALERT}{SETTINGS}</Card.Header>
        <Card.Body>
          <Row className="middle">
            <Col sm={8}>
              <Table bordered hover className="settings-table">
                <thead>
                  <tr>
                    <th className="section">{MEASUREMENT}</th>
                    <th className="section">{CONTEXT}</th>
                    <th className="section">{UPPER_BOUND}</th>
                    <th className="section">{LOWER_BOUND}</th>
                    <th className="section">{SEND_ALERT}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={4}>{BG}</td>
                    <td className="left">{FASTING}</td>
                    <td>{settings.fastingUpper}mmol/L</td>
                    <td>{settings.fastingLower}mmol/L</td>
                    <td>{settings.fastingRule}</td>
                  </tr>
                  <tr>
                    <td className="left">{AFTER_MEAL}</td>
                    <td>{settings.afterMealUpper}mmol/L</td>
                    <td>{settings.afterMealLower}mmol/L</td>
                    <td>{settings.afterMealRule}</td>
                  </tr>
                  <tr>
                    <td className="left">{LOW_VALUE}</td>
                    <td colSpan={2}></td>
                    <td>{settings.lowRule}</td>
                  </tr>
                  <tr>
                    <td className="left">{NO_VALUES}</td>
                    <td colSpan={2}></td>
                    <td>{settings.noDataRule}</td>
                  </tr>
                  <tr>
                    <td rowSpan={2}>{BP}</td>
                    <td className="left">{SYSTOLIC}</td>
                    {
                      settings.sysUpper === null ? <td></td> : <td>{settings.sysUpper}mmHg</td>
                    }
                    {
                      settings.sysLower === null ? <td></td> : <td>{settings.sysLower}mmHg</td>
                    }
                    <td>{settings.sysRule}</td>
                  </tr>
                  <tr>
                    <td className="left">{DIASTOLIC}</td>
                    {
                      settings.diaUpper === null ? <td></td> : <td>{settings.diaUpper}mmHg</td>
                    }
                    {
                      settings.diaLower === null ? <td></td> : <td>{settings.diaLower}mmHg</td>
                    }
                    <td>{settings.diaRule}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  return (
    <></>
  )

}
export default AlertSettingsDisplay;